// extracted by mini-css-extract-plugin
export var separator = "project-module--separator--29Ggm";
export var outerContainer = "project-module--outerContainer--j5Ni6";
export var projectContainer = "project-module--projectContainer--us-iZ";
export var title = "project-module--title--19vua";
export var date = "project-module--date--2ytip";
export var projectImage = "project-module--projectImage--ywnvS";
export var description = "project-module--description--1hNTg";
export var tag = "project-module--tag--1FHuc";
export var link = "project-module--link--NmClQ";
export var googlePlayLink = "project-module--googlePlayLink--2tyDv";